"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _file = require("@/api/file");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      fileList: {
        count: 0
      },
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 10
      },
      enabledOptions: [{
        key: "文档",
        display_name: "文档"
      }, {
        key: "图片",
        display_name: "图片"
      }, {
        key: "音频",
        display_name: "音频"
      }, {
        key: "视频",
        display_name: "视频"
      }, {
        key: "其它",
        display_name: "其它"
      }]
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _file.getFileList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.fileList = response.data;
        }
        _this.listLoading = false;
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    }
  }
};